/* ========================================= */
/* src/data/services.ts - DATOS DE SERVICIOS */
/* ========================================= */

/*
 * Este archivo contiene la información detallada de todos los servicios ofrecidos por Infinity Wits.
 * Cada servicio incluye:
 * - Información general (nombre, descripción, icono)
 * - Características y objetivos
 * - Alcance del servicio (scope) con imágenes representativas
 * - Tabla de precios
 * - Imagen principal del servicio
 */

import { Service } from '../types';

export const services: Service[] = [
  {
    id: 'servicios-electricos',
    name: 'Servicios Eléctricos',
    description: 'Instalación y mantenimiento de equipos eléctricos como tableros de control, generadores eléctricos, y líneas de electricidad para alumbrado y automatización. Utilizamos las mejores marcas del mercado y contamos con el mejor equipo técnico profesional para garantizar la calidad y seguridad en cada proyecto.',
    icon: '/images/03-servicios/icons/icon_service_electric.jpg',
    features: [
      'Instalación de tableros de control',
      'Mantenimiento de generadores eléctricos',
      'Sistemas de alumbrado automatizado',
      'Supervisión por equipo técnico profesional',
      'Uso de las mejores marcas del mercado'
    ],
    objectives: [
      'Asegurar el funcionamiento óptimo de los sistemas eléctricos',
      'Mejorar la eficiencia energética de las instalaciones',
      'Garantizar la seguridad de las operaciones eléctricas',
      'Proporcionar soluciones eléctricas duraderas y confiables'
    ],
    // ALCANCE DEL SERVICIO - Cada elemento incluye una imagen representativa del tipo de trabajo
    scope: [
      {
        name: 'Tableros de control de bombas de agua potable',
        // Imagen muestra tableros eléctricos instalados para control de bombas
        image: '/images/03-servicios/electricos/tablerocontrolbombas.png'
      },
      {
        name: 'Sistemas de control de líneas de enfriamiento',
        // Imagen representa sistemas de control para equipos de refrigeración industrial
        image: '/images/03-servicios/electricos/sitemaslineascontrolenfriamiento.png'
      }
    ],
    pricing: [
      {
        service: 'Instalación de tablero de control',
        price: 0,
        deliveryTime: 'Según proyecto',
        includes: ['Diseño y montaje', 'Pruebas y puesta en marcha', 'Asesoría técnica']
      },
      {
        service: 'Proyecto de alumbrado automatizado',
        price: 0,
        deliveryTime: 'Según proyecto',
        includes: ['Diseño de sistema', 'Instalación de cableado y luminarias', 'Configuración de automatización']
      }
    ],
    // Imagen principal del servicio - representa el trabajo eléctrico general
    image: '/images/03-servicios/electricos/tablerocontrolbombas.png'
  },
  {
    id: 'servicios-mantenimiento',
    name: 'Servicios de Mantenimiento',
    description: 'Instalación y mantenimiento de bombas eléctricas, tanto para agua potable como para aguas servidas. Nos especializamos en asegurar el funcionamiento óptimo y prolongar la vida útil de sus equipos.',
    icon: '/images/03-servicios/icons/icon_service_maintenance.png',
    features: [
    'Instalación profesional de bombas eléctricas',
    'Mantenimiento preventivo y correctivo',
    'Diagnóstico y reparación de fallas',
    'Asesoramiento técnico especializado',
    'Uso de repuestos de alta calidad'
    ],
    objectives: [
    'Garantizar el suministro constante de agua',
    'Prevenir averías costosas y paradas no programadas',
    'Optimizar el rendimiento de las bombas',
    'Aumentar la eficiencia energética del sistema'
    ],
    // ALCANCE DEL SERVICIO - Diferentes tipos de proyectos eléctricos según el sector
    scope: [
      {
        name: 'Instalación de bombas de agua para empresas',
        // Imagen muestra instalación eléctrica en viviendas familiares
        image: '/images/03-servicios/mantenimiento/inst_bombas_agua.png'
      },
      {
        name: 'Instalciones de bombas de achique',
        // Imagen representa proyectos de iluminación LED moderna y eficiente
        image: '/images/03-servicios/mantenimiento/inst_bombas_achique.png'
      }
    ],
    pricing: [
      {
      service: 'Instalación de bomba de agua',
      price: 0,
      deliveryTime: 'Según proyecto',
      includes: ['Evaluación del sitio', 'Selección e instalación del equipo', 'Pruebas de funcionamiento']
      },
      {
      service: 'Mantenimiento preventivo',
      price: 0,
      deliveryTime: 'Según evaluación',
      includes: ['Revisión general de la bomba', 'Limpieza y lubricación de componentes', 'Informe de estado']
     },
     {
      service: 'Mantenimiento correctivo',
      price: 0,
      deliveryTime: 'Según la falla',
      includes: ['Diagnóstico de avería', 'Reparación o reemplazo de piezas', 'Pruebas finales']
     }
    ],
    image: '/images/03-servicios/mantenimiento/mantenimientoicon.png'
  },
  {
    id: 'servicios-maquinaria',
    name: 'Servicios de maquinaria',
    description: 'Instalación y mantenimiento de componentes hidráulicos clave. Nos especializamos en la fabricación de pistones, instalación de manómetros y válvulas, y la reparación de bombas hidráulicas para asegurar el rendimiento óptimo de sus equipos.',
    icon: '/images/03-servicios/icons/icon_service_machine.png',
    features: [
    'Instalación de manómetros hidráulicos',
    'Fabricación de pistones hidráulicos a medida',
    'Reparación y/o instalación de bombas hidráulicas',
    'Instalación de válvulas hidráulicas de alta precisión'
    ],
    objectives: [
    'Garantizar el funcionamiento seguro y eficiente de los sistemas hidráulicos',
    'Maximizar la vida útil de los equipos',
    'Reducir el riesgo de fallos operativos y fugas',
    'Ofrecer soluciones hidráulicas personalizadas'
    ],
    // ALCANCE DEL SERVICIO - Diferentes componentes de sistemas renovables que mantenemos
    scope: [
      {
        name: 'Sistemas de gobierno para embarcaciones pesqueras (como el proyecto ALONDRA)',
        // Imagen muestra técnicos limpiando y revisando paneles solares
        image: '/images/03-servicios/maquinaria/pistones_embarcacion_pesquera.png'
      },
      {
        name: 'Sistemas de mandos para winches principales (como el proyecto ANTARES III)',
        // Imagen representa mantenimiento de inversores y equipos de conversión
        image: '/images/03-servicios/maquinaria/mandos_winche.png'
      }
    ],
    pricing: [
      {
        service: 'Fabricación de pistón hidráulico',
        price: 0,
        deliveryTime: 'Según especificaciones',
        includes: ['Diseño y fabricación', 'Pruebas de presión', 'Entrega e instalación']
      },
      {
      service: 'Reparación de bomba hidráulica',
      price: 0,
      deliveryTime: 'Según evaluación',
      includes: ['Diagnóstico de la avería', 'Reparación de componentes', 'Calibración y pruebas']
    
      },
      {
      service: 'Instalación de sistema hidráulico',
      price: 0,
      deliveryTime: 'Según proyecto',
      includes: ['Evaluación técnica', 'Selección e instalación de componentes', 'Puesta en marcha']
      },
    ],
    image: '/images/03-servicios/maquinaria/maquinariaicon.png'
  },
  {
    id: 'servicios-sci',
    name: 'Servicios contra Incendios (SCI)',
    description: 'Ofrecemos una solución integral de detección y extinción contra incendios, diseñada a la medida de las necesidades de su empresa. Implementamos sistemas modernos y eficientes para proteger sus activos y garantizar la seguridad de su personal.',
    icon: '/images/03-servicios/icons/icon_service_fire.png',
    features: [
    'Sistemas de redes húmedas contra incendios',
    'Sistemas de espuma para incendios Clase B',
    'Instalación de rociadores automáticos',
    'Sistemas de extinción con agua pulverizada',
    'Soluciones de extinción a gas para equipos sensibles',
    'Mantenimiento preventivo y correctivo de equipos'
    ],
    objectives: [
    'Proteger vidas y activos en caso de incendio',
    'Cumplir con las normativas de seguridad vigentes',
    'Minimizar los daños por fuego y humo',
    'Garantizar la operatividad de los sistemas de seguridad'
    ],
    // ALCANCE DEL SERVICIO - Tipos de consultoría según el sector y necesidad
    scope: [
      {
        name: 'Desarrollo de proyectos de redes húmedas',
        // Imagen muestra consultor realizando mediciones en hogar
        image: '/images/03-servicios/contraincendios/rociadoresautomaticos.png'
      }
    ],
    pricing: [
      {
service: 'Instalación de redes húmedas',
      price: 0,
      deliveryTime: 'Según proyecto',
      includes: ['Diseño del proyecto', 'Suministro e instalación de tuberías', 'Pruebas de presión y puesta en marcha']
      },
      {
service: 'Sistema de rociadores automáticos',
      price: 0,
      deliveryTime: 'Según proyecto',
      includes: ['Cálculo hidráulico', 'Instalación de rociadores y cabezales', 'Integración al sistema de alarma']
      },
      {
        service: 'Mantenimiento de SCI',
        price: 0,
        deliveryTime: 'Según contrato',
        includes: ['Inspección periódica de equipos', 'Pruebas de funcionamiento', 'Reportes de mantenimiento']
      }
    ],
    image: '/images/03-servicios/contraincendios/rociadoresautomaticos.png'
  }
];

/*
 * ESTRUCTURA DE CARPETAS DE IMÁGENES:
 * 
 * public/images/03-servicios/
 * ├── electricos/
 * │   ├── tablerocontrolbombas.png (existente)
 * │   ├── sistema-enfriamiento.jpg
 * │   ├── generador-electrico.jpg
 * │   └── alumbrado-automatizado.jpg
 * ├── proyectos/
 * │   ├── instalacion-residencial.jpg
 * │   ├── instalacion-comercial.jpg
 * │   ├── instalacion-industrial.jpg
 * │   └── iluminacion-led.jpg
 * ├── mantenimiento/
 * │   ├── paneles-solares.jpg
 * │   ├── inversores.jpg
 * │   ├── limpieza-sistemas.jpg
 * │   └── diagnostico.jpg
 * └── consultoria/
 *     ├── auditoria-residencial.jpg
 *     ├── viabilidad-comercial.jpg
 *     ├── energias-renovables.jpg
 *     └── certificaciones.jpg
 * 
 * RELACIÓN IMAGEN-SCOPE:
 * - Cada imagen representa visualmente el tipo de trabajo específico del scope
 * - Las imágenes ayudan al usuario a entender rápidamente el alcance del servicio
 * - Se organizan por categoría de servicio para facilitar el mantenimiento
 * - Las rutas son relativas al directorio public para acceso web directo
 * 
 * 
 * gerencia@infinitywits.com
 * entas@infinitywits.com
 * operaciones@cppvyf.com
 */